import {
    Layout1, Layout2, Layout3,
    Layout4
} from "../../../public/siteImages/HomePageLayout";
import messages from "../../locale/jsonMessages";

export function getHomePagePreview({ homePageType }) {
    let layout = [];
    if (homePageType == 1) layout = [Layout1];
    else if (homePageType == 2) layout = [Layout2];
    else if (homePageType == 3) layout = [Layout3];
    else layout = [Layout4];
    return layout;
}

export function getPreviewLabel({ formatMessage, homePageType }) {
    let label;
    if (homePageType == 1) label = formatMessage(messages.homePageLayoutDesc);
    else if (homePageType == 2) label = formatMessage(messages.homePageLayoutDesc1);
    else if (homePageType == 3) label = formatMessage(messages.homePageLayoutDesc2);
    else label = formatMessage(messages.homePageLayoutDesc3);
    return label;
}